import constants from '@constants';

export const getErrorMessage = (message: string) => {
  switch (message) {
    case 'email is not unique':
      return 'のメールアドレスは既に登録されています';
    case 'phoneNumber is not unique':
      return 'の携帯番号はチーム内で既に登録されています';
    case 'validation error':
      return 'の書式が正しくありません';
    case 'Network Error':
      return 'ネットワークエラー';
    case 'An account with the given email already exists.':
      return 'のメールアドレスは既に特権管理者もしくは管理者として登録済みです';
    case 'unknown error':
      return constants.ERRORS.UNKNWON;
    default:
      return constants.ERRORS.UNKNWON;
  }
};
